'use client'

import type { Transaction } from '../hooks/useTransactionHistory'

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function exportTransactionsToCSV(transactions: Transaction[], filename?: string) {
  const headers = [
    'Date',
    'Time',
    'Type',
    'Status',
    'Amount (USD)',
    'Local Amount',
    'Local Currency',
    'Flow',
    'Merchant',
    'Category',
    'MCC',
    'City',
    'Country',
    'Transaction ID',
    'On-chain TX Hash',
    'On-chain Status',
    'Settlement Status',
  ]

  const rows = transactions.map((t) => {
    const date = new Date(t.created_at)

    return [
      date.toLocaleDateString('en-US'),
      date.toLocaleTimeString('en-US'),
      t.type,
      t.status,
      t.amount.toFixed(2),
      t.local_amount?.toFixed(2) ?? '',
      t.local_currency ?? '',
      t.flow,
      escapeCSV(t.merchant.name),
      escapeCSV(t.merchant.category ?? ''),
      t.merchant.mcc ?? '',
      escapeCSV(t.merchant.city ?? ''),
      escapeCSV(t.merchant.country ?? ''),
      t.id,
      t.onchain_tx_hash ?? '',
      t.onchain_status ?? '',
      t.settlement_status,
    ]
  })

  const csvContent = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename ?? `hypurr-transactions-${new Date().toISOString().split('T')[0]}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
